import AnalyticsEvent from './analyticsEvent';

const discoveryEvents = {
  discoveryTileGenerateClick: (params: {
    type: string;
    genre: string;
  }): AnalyticsEvent =>
    AnalyticsEvent.createEvent('discovery_tile_generate', params),
};

export default discoveryEvents;
